<footer class="">
  <div #lntFooterLogo style="background-image:url('../edmsui/assets/images/L&T-Logo_1.png')" class="lntlogo">
    <!-- <span class="serveStyle">{{server}}</span> -->
  </div>
  <div class="privpol_copyright">
    <span class="copyright_text">EDMS © {{currentYear}} L&T Construction. All Rights Reserved</span>
  </div>
</footer>